import React, { useEffect, useState } from 'react';
import './App.css';
import './assets/css/style.css';
import Header from './components/Header';
import UpdatedSlider from './components/UpdatedSlider';
import Features from './components/Features';
import About from './components/About';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import TermsConditions from './components/terms_conditions';
import PrivacyPolicy from './components/privacy_policy';
import OurTeam from './components/OurTeam';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

// ===== Scroll to hash on route change =====
function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  return null;
}

// ===== Scroll to Top Button Component =====
// ===== Scroll to Top Button (Styled like your template) =====
function ScrollToTopButton() {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) setVisible(true);
      else setVisible(false);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {visible && (
        <div
          className="scroll-to-top"
          onClick={scrollToTop}
          style={{
            position: "fixed",
            right: "20px",
            bottom: "30px",
            width: "50px",
            height: "50px",
            backgroundColor: "#ff0000",
            color: "#fff",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "24px",
            cursor: "pointer",
            boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
            transition: "all 0.3s ease",
            zIndex: 9999,
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-3px)";
            e.currentTarget.style.boxShadow = "0 6px 12px rgba(0,0,0,0.4)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.3)";
          }}
        >
          <i className="fa fa-angle-up"></i>
        </div>
      )}
    </>
  );
}


function App() {
  useEffect(() => {
    // ===== Preloader =====
    const preloader = document.querySelector('.preloader');
    if (preloader) {
      setTimeout(() => {
        preloader.style.display = 'none';
      }, 1000);
    }

    // ===== WOW.js animations =====
    if (window.WOW) {
      const wow = new window.WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true
      });
      wow.init();
    }

    // ===== Swiper slider init =====
    // Swiper initialized by public/assets/js/main.js on window load to avoid double init

    // ===== Mobile menu toggle =====
    const mobileNavToggler = document.querySelector('.mobile-nav__toggler');
    const mobileNavWrapper = document.querySelector('.mobile-nav__wrapper');

    if (mobileNavToggler) {
      mobileNavToggler.addEventListener('click', function (e) {
        e.preventDefault();
        if (mobileNavWrapper) {
          mobileNavWrapper.classList.toggle('expanded');
          document.body.classList.toggle('locked');
        }
      });
    }

    // ===== Smooth scroll for anchor links =====
    const scrollLinks = document.querySelectorAll('a[href^="#"]');
    scrollLinks.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = this.getAttribute('href');
        if (targetId === '#') return;

        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      });
    });

  }, []);

  return (
    <Router>
      <ScrollToHash />

      <div className="page-wrapper">
        {/* Preloader */}
        <div className="preloader">
          <img
            className="preloader__image"
            width="60"
            src="/assets/images/suhani/logo_favicon.png"
            alt="Loading"
          />
        </div>

        <Header />

        <Routes>
          <Route
            path="/"
            element={
              <>
                <UpdatedSlider />
                <Features />
                <section id="aboutus"><About /></section>
                <section id="gallery"><Gallery /></section>
                <section id="testimonial"><Testimonials /></section>
                <section id="ourteam"><OurTeam /></section>
                <section id="contactus"><Contact /></section>
              </>
            }
          />
          <Route path="/terms-conditions.html" element={<TermsConditions />} />
          <Route path="/privacy-policy.html" element={<PrivacyPolicy />} />
        </Routes>

        <Footer />
        {/* ===== Scroll to Top Button ===== */}
        <ScrollToTopButton />
      </div>
    </Router>
  );
}

export default App;



// <IfModule mod_rewrite.c>
//     <IfModule mod_negotiation.c>
//         Options -MultiViews -Indexes
//     </IfModule>

//     RewriteEngine On

//     # Handle Authorization Header
//     RewriteCond %{HTTP:Authorization} .
//     RewriteRule .* - [E=HTTP_AUTHORIZATION:%{HTTP:Authorization}]

//     # Redirect Trailing Slashes If Not A Folder...
//     RewriteCond %{REQUEST_FILENAME} !-d
//     RewriteCond %{REQUEST_URI} (.+)/$
//     RewriteRule ^ %1 [L,R=301]

//     # Handle Front Controller...
//     RewriteCond %{REQUEST_FILENAME} !-d
//     RewriteCond %{REQUEST_FILENAME} !-f
//     RewriteRule ^ index.php [L]

// 	# ensure https
// 	RewriteCond %{HTTP:X-Forwarded-Proto} !https
// 	RewriteCond %{HTTPS} off
// 	RewriteRule ^ https://%{HTTP_HOST}%{REQUEST_URI} [L,R=301]

//     <Files .env>
//       order allow,deny
//       Deny from all
//   </Files>
// </IfModule>

// <Files 403.shtml>
// order allow,deny
// allow from all
// </Files>
